// @ts-nocheck
import {FC} from 'react'
import {Row} from 'react-table'
import {Event} from '../../core/_models'

type Props = {
  row: Row<Event>
}

const CustomRow: FC<Props> = ({row}) => {
  const rowProps = row.getRowProps()
  const {key: rowKey, ...rowRestProps} = rowProps

  return (
    <tr key={rowKey} {...rowRestProps}>
      {row.cells.map((cell) => {
        const cellProps = cell.getCellProps()
        const {key: cellKey, ...cellRestProps} = cellProps
        
        return (
          <td key={cellKey} {...cellRestProps}>
            {cell.render('Cell')}
          </td>
        )
      })}
    </tr>
  )
}

export {CustomRow}
